import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StaticInfoFieldMenuItem } from 'Angular/services/static-menus/interfaces/static-info-field-menu.interface';

import { InfoFieldSelectorModalDirective } from 'SecuritiesApp/ts/info-field-selector-modals/info-field-selector-modal/info-field-selector-modal.directive';

/**
 * Single Info Field Selector Modal Component
 *
 * Modal that shows the static menu of info fields and lets a single info field be selected.
 * The modal closes on selection.
 *
 * Input Properties:
 *  infoType: 'company', 'fund', 'all', etc.
 *  selectedInfoField: info field that should start out as selected.
 *
 * Output Properties:
 *  selectInfoFieldHandler: emits the info field that was selected.
 */
@Component({
    standalone: false,
    selector: 'ycn-single-info-field-selector-modal',
    templateUrl: './single-info-field-selector-modal.template.html',
})
export class SingleInfoFieldSelectorModalComponent extends InfoFieldSelectorModalDirective {
    @Input() selectedInfoField?: StaticInfoFieldMenuItem;

    @Output() selectInfoFieldHandler = new EventEmitter<StaticInfoFieldMenuItem>();

    openModal(): void {
        this.modalOpen = true;
        if (this.selectedInfoField) {
            this.selectedInfoFields = [this.selectedInfoField];
        }
    }

    closeModal(): void {
        this.modalOpen = false;
    }

    selectInfoField(infoField: StaticInfoFieldMenuItem): void {
        if (this.selectedInfoFields.length && infoField.key === this.selectedInfoFields[0].key) {
            // Deselect the info field since the selected info field was clicked again
            this.selectedInfoFields = [];
        } else {
            if (this.featureService.validateFeatureNeeded([infoField], this.featureNeededModal).length > 0) {
                this.selectInfoFieldHandler.emit(infoField);
            }
            this.closeModal();
        }
    }
}
